export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives16.7c78ffd1.jpg";